// Generated from backend/workers/core-backend/port-manifest.json. Do not edit:
// change a status there, then run `node scripts/routed-functions.ts` from
// backend/workers/core-backend (Node 24).

export const ROUTED_FUNCTIONS_OPT_IN: readonly string[] = [
  'ads-advertiser-review-api',
  'ads-api',
  'brand-font-delete',
  'brand-kit-actions',
  'check-url-safety',
  'clip-studio-actions',
  'correspondence-actions',
  'correspondence-interactions',
  'correspondence-saved-view-counts',
  'delete-comment',
  'email-metadata-counter',
  'facebook-historical-backfill',
  'feature-flags',
  'gdrive-list-folders',
  'gdrive-sync',
  'get-comments',
  'get-voice-profile',
  'import-constituents',
  'import-jobs',
  'members-remove-organization-member',
  'members-remove-staff-member',
  'members-reset-mfa',
  'members-suspend-staff-member',
  'mention-share-decision',
  'mfa-clear-unverified-factors',
  'minrep-body-image-upload',
  'newsroom-actions',
  'org-signature-upload',
  'pulse-ai-admin-review',
  'pulse-ai-asset-delete',
  'render-email',
  'reporting-widget-data',
  'resolve-comment',
  'save-email-to-knowledge',
  'set-external-share-policy',
  'set-org-profile',
  'set-voice-profile',
  'social-profile-actions',
  'suppressions-import',
  'template-reconstruction-actions',
  'toggle-comment-reaction',
  'update-comment',
  'validate-library-dataset',
];

export const ROUTED_FUNCTIONS_EVERYONE: readonly string[] = ['creative-image-mask'];
